<template>
<div :aria-busy="loading ? 'true' : 'false'">
		<div v-if="!loading">
			<alert :conditional="user.fb_page_id === null && user.organization.is_mandatoaberto !== 0"
				:classFather="'alert'"
				:message="'alert-facebook'"
				:alert-class-children="'alert--square'"
				:iconClass="'icon fas fa-warning'"
				:linkShow="true"
				:linkTo="'/perfil'"
				:linkText="'configure'"
				:altLink="'configure-facebook'"
				:close-button="true">
			</alert>

			<section class="content__custom">
					<div class="main-title">
						<h1 class="dashboard">
							{{ 'indicators' | translate | titleCase }}
						</h1>
					</div>

				<div class="tabs">
					<nav class="tabs__navigation">
						<ul>
							<li :class="`${activeSection === 'ultima-semana' ? 'tabs__navigation--active' : ''}`" @click="getLastWeekAnalytics()">
								<a href="#ultima-semana" @click.prevent="changeSection('ultima-semana')">
									{{ 'Última semana' | translate }}
								</a>
							</li>
							<li :class="`${activeSection === 'visao-geral' ? 'tabs__navigation--active' : ''}`" @click="getAnalytics()">
								<a href="#visao-geral" @click.prevent="changeSection('visao-geral')">
									{{ 'Visão geral' | translate }}
								</a>
							</li>
						</ul>
					</nav>
					<section id="ultima-semana" :class="`tab__entry-content  ${activeSection === 'ultima-semana' ? 'tab__entry-content--active' : ''}`">
						<lastWeek></lastWeek>
					</section>
					<section id="visao-geral" :class="`tab__entry-content  ${activeSection === 'visao-geral' ? 'tab__entry-content--active' : ''}`">
						<overview></overview>
					</section>
				</div>
			</section>
		</div>
	</div>
</template>
<script>

import alert from '../../components/alert/alert.vue';
import overview from './overview.vue';
import lastWeek from './lastWeek.vue';

export default {
	name: 'metrics',
	components: {
		alert,
		overview,
		lastWeek,
	},
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			loading: false,
			activeSection: 'ultima-semana',
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
		getLastWeekAnalytics() {
			this.toggleLoading();
			this.$store.dispatch('getLastWeekAnalytics', this.session)
				.then(() => {
					this.toggleLoading();
				})
				.catch(() => {
					this.toggleLoading();
				});
		},
		getAnalytics() {
			this.toggleLoading();
			this.$store.dispatch('getAnalytics', this.session)
				.then(() => {
					this.toggleLoading();
				})
				.catch(() => {
					this.toggleLoading();
				});
		},
		changeSection(section) {
			this.activeSection = section;
		},
	},
	mounted() {
		this.getLastWeekAnalytics();
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/metrics/metrics.vue